import { useState, useEffect, useMemo } from 'react';
import Loader from '../../../../components/Loader';
import MessageCard from '../../../../components/Messaging/MessageCard';
import MessageSkeleton from '../../../../components/Messaging/MessageSkeleton';
import Scrollbar from 'react-scrollbars-custom';
import useIsMobile from '../../../../components/Custom/useIsMobile';

const ChatWindow = ({
  readPersonalChats = [],
  group,
  chatUsers,
  editId,
  setEditId,
  setEditText,
  scrollRef,
  isInModal,
  handleDeleteMessage,
  isLoading = false
}) => {
  const isMobile = useIsMobile();
  const [visibleCount, setVisibleCount] = useState(5);
  const [loadingMore, setLoadingMore] = useState(false);

  // ✅ Memoize to prevent new array creation each render
  const displayedMessages = useMemo(() => {
    return readPersonalChats.slice(-visibleCount);
  }, [readPersonalChats, visibleCount]);

  const handleChatScroll = (e) => {
    if (e.scrollTop === 0 && !loadingMore && visibleCount < readPersonalChats.length) {
      setLoadingMore(true);
      const previousHeight = e.scrollHeight;

      setTimeout(() => {
        setVisibleCount((prev) => Math.min(prev + 5, readPersonalChats.length));
        setLoadingMore(false);

        requestAnimationFrame(() => {
          if (scrollRef.current) {
            const newHeight = scrollRef.current.scrollHeight;
            scrollRef.current.scrollTop = newHeight - previousHeight;
          }
        });
      }, 500);
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [scrollRef, displayedMessages]);

  return (
    <Scrollbar
      width={3}
      ref={scrollRef}
      onScroll={handleChatScroll}
      className="chat-messages-container d-flex flex-column"
      style={{
        height: isInModal ? isMobile ? '331px' : '405px' : '44vh',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <style>{`
        .chat-messages-container::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      {loadingMore && (
        <div className="text-center">
          <Loader
            padding={20}
            size={{ width: '2rem', height: '2rem' }}
            loading={true}
            local={true}
            customBg={'rgba(0,0,0,0)'}
            viewClass="bg-transparent"
          />
        </div>
      )}

      {isLoading ? (
        <MessageSkeleton count={3} />
      ) : (
        displayedMessages.map((data, index) => (
          <MessageCard
            key={data.id || index}
            group={group}
            data={data}
            index={index}
            chatUsers={chatUsers}
            editId={editId}
            setEditId={setEditId}
            setEditText={setEditText}
            handleDeleteMessage={handleDeleteMessage}
          />
        ))
      )}
    </Scrollbar>
  );
};

export default ChatWindow;
